export class CertificateModel {
  tipo: string;
  validade: Date;
  fantasia: string;
  cnpj: string;

  constructor(data?: Partial<CertificateModel>) {
    Object.assign(this, data);
  }
}
